import { DigitalProductErrorInterface } from 'modules/digital-product/types/digital-product-interface'
import { ProductDownloadItemErrorsType } from 'modules/stores/store/content/product/types/product-interface'
import {
  getDigitalProductCheckoutErrorChecker,
  getThankYouErrorChecker,
  getThumbnailErrorChecker,
} from 'modules/stores/store/utils/get-error-checkers'
import { useFormErrorMessageInTabs } from 'modules/stores/store/utils/use-form-error-message-in-tabs'
import { ProductDownloadTabEnum, tabLocoKeys } from '../enum/product-download-tab-enum'
import { getProductDownloadError } from '../utils/get-product-download-error'

export const useErrorMessageInTabs = () => {
  const { formErrorMessage: formErrorMessageCommon } = useFormErrorMessageInTabs()

  const getTabsWithErrors = ({
    errors,
    digitalProductErrors,
  }: {
    errors: ProductDownloadItemErrorsType
    digitalProductErrors: DigitalProductErrorInterface
  }): Record<ProductDownloadTabEnum, boolean> => {
    const hasThumbnailError = getThumbnailErrorChecker(errors)

    const hasCheckoutError = getDigitalProductCheckoutErrorChecker(errors, digitalProductErrors)

    const hasThankYouError = getThankYouErrorChecker(errors)

    const hasProductErrors = getProductDownloadError(errors, digitalProductErrors)

    return {
      [ProductDownloadTabEnum.digital_download]: hasProductErrors,
      [ProductDownloadTabEnum.thumbnail]: hasThumbnailError,
      [ProductDownloadTabEnum.checkout]: hasCheckoutError,
      [ProductDownloadTabEnum.thank_you]: hasThankYouError,
    }
  }

  const formErrorMessage = ({
    errors,
    digitalProductErrors,
  }: {
    errors: ProductDownloadItemErrorsType
    digitalProductErrors: DigitalProductErrorInterface
  }) => {
    const tabsErrorsMap = getTabsWithErrors({ errors, digitalProductErrors })
    return formErrorMessageCommon({ tabsErrorsMap, tabsLocoKeys: tabLocoKeys })
  }

  return {
    getTabsWithErrors,
    formErrorMessage,
  }
}
